export default __webpack_public_path__ + "static/media/search.496fd007.svg";